import { HistoryComponent } from './history.component';

export const HistoryRoutes: Array<any> = [
  {
    path: 'history',
    component: HistoryComponent,
    canActivate: [],
  },
];



// WEBPACK FOOTER //
// ./src/app/components/dashboard/history/history.routes.ts